import { IconArrowLeft } from "@tabler/icons-react";
import {useDB} from "../Services/useDB";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import ImageWithClose from "../Components/Default/ImageWithClose";
import FolderSidebar from "../Components/Event/FolderSidebar";
import PhotoAlbumTagger from "../Components/Event/PhotoAlbumTagger";
import {toast} from "react-toastify";


export function Event() {
    const { eventID } = useParams();
    const { getEvent, getPictures, enableEvent, updateEvent, getFolders, createFolder, updateFolder, deleteFolder } = useDB();
    const [pictures, setPictures] = useState([]);
    const [ event, setEvent ] = useState(null);
    const [folders, setFolders] = useState([]);
    const [activeFolderId, setActiveFolderId] = useState(null);
    const [editingFolderId, setEditingFolderId] = useState(null);
    const [selectedPictureIds, setSelectedPictureIds] = useState(new Set());


    const [image, setImage] = useState(
        "https://www.pfadi-dornbirn.at/wp-content/uploads/2025/03/2-1-300x200.jpg"
    );

    const handleRemove = () => setImage(null);
    const handleUpload = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => setImage(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleCheckboxChange = () => {
        // Toggle den Wert von 'allowDownload'
        setEvent(prevEvent => ({
            ...prevEvent,           // Bewahre alle anderen Eigenschaften bei
            allowDownload: !prevEvent.allowDownload,  // Schalte den Wert von 'allowDownload'
        }));
    };

    const handleInputChange = (e) => {
        setEvent({
            ...event,
            eventName: e.target.value,  // Setze den neuen Wert des Textfelds
        });
    };

    const handleSave = async () => {
        if(!event) return;
        console.log("EVENT", event);

        const result = await updateEvent(event);

        console.log("SAVE", result);
    }

    const handleEnableEvent = async () => {
        if (!eventID) return;

        try {
            const result = await enableEvent(eventID); // enableEvent mit der eventID aufrufen
            if (result) {
                toast.success("Event erfolgreich aktiviert!");
            } else {
                toast.error("Fehler beim Aktivieren des Events.");
            }
        } catch (error) {
            toast.error("Fehler beim Aufrufen des Events.");
        }
    };

    useEffect(() => {
        getEvent(eventID).then(data => {
            if (data) setEvent(data);
        });
    }, [eventID]);

    useEffect(() => {
        const fetchPictures = async () => {
            setPictures(await getPictures(eventID));
        };

        fetchPictures();
    }, []);

    const refreshFolders = async () => {
        const data = await getFolders(eventID);
        if (data) setFolders(data);
    };

    useEffect(() => {
        refreshFolders();
    }, [eventID]);

    const activeFolder = folders.find(f => f._id === activeFolderId);
    const displayedPictures = activeFolder
        ? pictures.filter(p => activeFolder.pictureIds.includes(p._id))
        : pictures;

    const handleCreateFolder = async (name) => {
        const created = await createFolder(eventID, name);
        if (created) {
            await refreshFolders();
            handleStartEdit(created);
        }
    };

    const handleRenameFolder = async (folderId, name) => {
        const updated = await updateFolder(folderId, { name });
        if (updated) await refreshFolders();
    };

    const handleDeleteFolder = async (folderId) => {
        if (!window.confirm("Delete this folder? Pictures themselves are not deleted.")) return;
        const deleted = await deleteFolder(folderId);
        if (deleted) {
            if (activeFolderId === folderId) setActiveFolderId(null);
            await refreshFolders();
        }
    };

    const handleStartEdit = (folder) => {
        setEditingFolderId(folder._id);
        setSelectedPictureIds(new Set(folder.pictureIds));
    };

    const handleCancelEdit = () => {
        setEditingFolderId(null);
        setSelectedPictureIds(new Set());
    };

    const handleSaveEdit = async () => {
        const updated = await updateFolder(editingFolderId, { pictureIds: Array.from(selectedPictureIds) });
        if (updated) {
            await refreshFolders();
            setEditingFolderId(null);
            setSelectedPictureIds(new Set());
        }
    };

    const togglePictureSelection = (pictureId) => {
        setSelectedPictureIds(prev => {
            const next = new Set(prev);
            if (next.has(pictureId)) next.delete(pictureId);
            else next.add(pictureId);
            return next;
        });
    };

    const handleCreateFolderForTag = async (name) => {
        const created = await createFolder(eventID, name);
        if (created) await refreshFolders();
        return created;
    };

    const handleAddPictureToFolder = async (folderId, pictureId) => {
        const folder = folders.find(f => f._id === folderId);
        if (!folder || folder.pictureIds.includes(pictureId)) return;
        const updated = await updateFolder(folderId, { pictureIds: [...folder.pictureIds, pictureId] });
        if (updated) await refreshFolders();
    };

    const handleRemovePictureFromFolder = async (folderId, pictureId) => {
        const folder = folders.find(f => f._id === folderId);
        if (!folder) return;
        const updated = await updateFolder(folderId, { pictureIds: folder.pictureIds.filter(id => id !== pictureId) });
        if (updated) await refreshFolders();
    };

    return (
        <div className="container-fluid mt-4">
            <div className="row row-cards">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">{event && event.eventName}</h4>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label className="form-label">Event Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={event && event.eventName}
                                            placeholder="Input placeholder"
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Snap Download</label>
                                        <div className="form-selectgroup form-selectgroup-boxes d-flex flex-column">
                                        <label className="form-selectgroup-item flex-fill">
                                                <input
                                                    type="checkbox"
                                                    name="form-project-manager[]"
                                                    value="1"
                                                    className="form-selectgroup-input"
                                                    checked={event && event.allowDownload}
                                                    onChange={handleCheckboxChange}
                                                />

                                                <div className="form-selectgroup-label d-flex align-items-center p-3">
                                                    <div className="me-3">
                                                        <span className="form-selectgroup-check"></span>
                                                    </div>
                                                    <div
                                                        className="form-selectgroup-label-content d-flex align-items-center">
                                                        <div>
                                                            <div className="font-weight-medium">Downloads erlauben</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-6">
                                    <div className="mb-3">
                                        <ImageWithClose
                                            src={`${process.env.REACT_APP_BACKEND_API_URL}/s3/file/${event && event.rahmenbild}`}/>

                                        <ImageWithClose
                                            src={`${process.env.REACT_APP_BACKEND_API_URL}/s3/file/${event && event.overlaybild}`}/>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-end">
                            <div className="d-flex justify-content-end gap-3">
                                <button type="submit" className="btn btn-success" onClick={handleEnableEvent}>Aktivieren</button>
                                <button type="submit" className="btn btn-primary" onClick={handleSave}>Speichern</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-3">
                    <FolderSidebar
                        folders={folders}
                        activeFolderId={activeFolderId}
                        editingFolderId={editingFolderId}
                        onSelectFolder={setActiveFolderId}
                        onCreateFolder={handleCreateFolder}
                        onRenameFolder={handleRenameFolder}
                        onDeleteFolder={handleDeleteFolder}
                        onStartEdit={handleStartEdit}
                        onSaveEdit={handleSaveEdit}
                        onCancelEdit={handleCancelEdit}
                        zipBaseUrl={process.env.REACT_APP_BACKEND_API_URL}
                    />
                </div>
                <div className="col-9">
                    <div className="card">
                        <div className="page-header d-print-none">
                            <div className="container-fluid">
                                <div className="row g-2 align-items-center">
                                    <div className="col">
                                        <div className="page-pretitle">{event && event.eventName}</div>
                                        <h2 className="page-title">
                                            {activeFolder ? activeFolder.name : "Pictures"}
                                        </h2>
                                    </div>
                                    {editingFolderId && (
                                        <div className="col-auto">
                                            <span className="text-muted">Click pictures to add/remove from folder</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            {editingFolderId ? (
                                displayedPictures.length > 0 && displayedPictures.map((picture, index) => (
                                    <div
                                        className={`picture-select-item ${selectedPictureIds.has(picture._id) ? "picture-select-item-selected" : ""}`}
                                        key={index}
                                        onClick={() => togglePictureSelection(picture._id)}
                                    >
                                        <img className="roundedimage"
                                             src={`${process.env.REACT_APP_BACKEND_API_URL}/s3/file/thumb_${picture.image}`} alt=""/>
                                    </div>
                                ))
                            ) : (
                                <PhotoProvider
                                    overlayRender={({ images, index }) => {
                                        const currentSrc = images[index] && images[index].src;
                                        const currentPicture = displayedPictures.find(
                                            p => `${process.env.REACT_APP_BACKEND_API_URL}/s3/file/${p.image}` === currentSrc
                                        );
                                        return (
                                            <PhotoAlbumTagger
                                                picture={currentPicture}
                                                folders={folders}
                                                onCreateFolder={handleCreateFolderForTag}
                                                onAddToFolder={(folderId) => handleAddPictureToFolder(folderId, currentPicture._id)}
                                                onRemoveFromFolder={(folderId) => handleRemovePictureFromFolder(folderId, currentPicture._id)}
                                            />
                                        );
                                    }}
                                >
                                    {displayedPictures.length > 0 && displayedPictures.map((picture, index) => (
                                        <PhotoView key={index} src={`${process.env.REACT_APP_BACKEND_API_URL}/s3/file/${picture.image}`}>
                                            <img className="roundedimage"
                                                 src={`${process.env.REACT_APP_BACKEND_API_URL}/s3/file/thumb_${picture.image}`} alt=""/>
                                        </PhotoView>
                                    ))}
                                </PhotoProvider>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}